import { css } from '@lastbrand/web-ui-styled-system/css'

import type { SystemStyleObject } from '@lastbrand/web-ui-styled-system/types'

// Panda twin of the `.titleAndPriceSection_newDesignV2` block in BundleProductCard.module.scss.

export const titleAndPriceSectionRawCss = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
})

export const titleAndPriceSectionCss = css(titleAndPriceSectionRawCss)

// ProductTileBundle "upsell" header row spec (STRFRNT-16944): [title + price stack] then
// checkbox top-right, `gap: space-16`, `alignItems: 'flex-start'` so the checkbox stays
// pinned to the top against a 2-line-clamped title. Scoped to the add-on tile only so the
// Default (non-add-on) tile can't drift with future upsell edits.
export const addOnTitleAndPriceSectionCss = css.raw({
  alignItems: 'flex-start',
  gap: 'space-16',
})

// `css.raw` (not `css`) so the add-on variant composes over this base via
// `mergeLegacyResponsiveStyles(titleRawCss, addOnTitleClampCss)` at the call site — same
// convention as `bundle-product-card-ds.styles.ts`. `titleCss` below is the compiled class
// the Default (non-add-on) tile renders directly.
export const titleRawCss = css.raw({
  textStyle: 'body-14',
  mb: 'space-4',
})

export const titleCss = css(titleRawCss)

// Upsell-only: title is 2-line-clamped with ellipsis per the ProductTileBundle spec — the
// Default (non-add-on) tile title is untouched.
export const addOnTitleClampCss = css.raw({
  color: 'black',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  lineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const pricingCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  textStyle: 'body-14',
})

export const salePriceCss = css({
  fontWeight: 400,
})

export const salePriceBeforeBundleDiscountCss = css({
  fontWeight: 400,
  textDecoration: 'line-through',
  color: 'mediumgray',
})

// The row's own `gap: space-16` (titleAndPriceSectionCss) is the spec's header-row spacing;
// no local margin needed on this (checkbox) side of the flex row.
export const checkboxAndTitleCss = css({
  display: 'flex',
})

// Passed to web-ui's `css`/`labelCss` props, which take a raw SystemStyleObject, not a compiled class string.
export const checkboxWrapperStyle: SystemStyleObject = {
  marginTop: 'space-2',
}

export const checkboxLabelStyle: SystemStyleObject = {
  marginLeft: 'space-6',
}
